export default __webpack_public_path__ + "static/media/FoothillsMap.690805fa.jpg";